import React, { useEffect, useContext } from 'react';
import {
  array,
  bool,
  string,
  oneOf,
  oneOfType,
  shape,
  func,
  number
} from 'prop-types';
import { ExperienceContext, useDomPath } from '@thd-nucleus/experience-context';
import { Button } from '@thd-olt-component-react/button';
import '../add-to-cart.scss';


const AddToCart = (props) => {
  const { channel } = useContext(ExperienceContext);


  const {
    cartReqParams,
    cartOptions,
    disabled,
    onAddToCartClick,
    children,
    outline,
    className,
    cta,
    specialty,
    link,
    showBOPISOverlay,
    onClick,
    onSuccess,
    onFail,
    onError
  } = props;
  useEffect(() => {
    LIFE_CYCLE_EVENT_BUS.lifeCycle.trigger('add-to-cart.ready');
  }, []);

  const [path, ref] = useDomPath();

  return (
    <div className="">
      <Button
        ref={ref}
        disabled={disabled}
        outline={outline}
        small={channel === 'mobile'}
        className={className}
        cta={cta}
        specialty={specialty}
        link={link}
        onClick={(event) => {
          if (disabled && onError) {
            onError();
          } else if (!disabled) {
            if (onClick) onClick();
            if (showBOPISOverlay) {
              window.LIFE_CYCLE_EVENT_BUS.trigger('cart.select-store', {
                cartReqParams
              });
            } else {
              window.LIFE_CYCLE_EVENT_BUS.trigger('cart.add-to-cart', {
                cartReqParams,
                cartOptions,
                onAddToCartClick,
                onSuccess,
                onFail,
                path
              });
            }
          }
        }}
      >
        {children}
      </Button>
    </div>
  );
};

AddToCart.displayName = 'AddToCart';

AddToCart.propTypes = {
  cartOptions: shape({
    directCheckout: bool,
    host: string,
    misship: bool,
    paypal: bool
  }),
  cartReqParams: oneOfType([
    array,
    shape({
      attachedLabor: shape({
        attachedLaborSku: string
      }),
      fulfillmentLocation: string,
      fulfillmentMethod: string,
      itemId: string,
      quantity: number,
      service: shape({
        selected: bool,
        type: string
      }),
      subscriptions: shape({
        frequency: string
      }),
      warrantyItem: shape({
        itemId: string
      }),
    })
  ]),
  children: string.isRequired,
  className: string,
  cta: bool,
  disabled: bool,
  onAddToCartClick: func,
  onClick: func,
  onError: func,
  onFail: func,
  onSuccess: func,
  outline: bool,
  specialty: bool,
  showBOPISOverlay: bool,
  link: bool,
};

AddToCart.defaultProps = {
  cartOptions: {
    channel: 'desktop',
    host: 'https://www.homedepot.com',
    misship: false,
    paypal: false
  },
  cartReqParams: {
    itemId: null,
    quantity: 1
  },
  className: null,
  cta: false,
  disabled: false,
  onAddToCartClick: () => {},
  onClick: () => {},
  onError: null,
  onFail: () => {},
  onSuccess: () => {},
  outline: false,
  showBOPISOverlay: false,
  specialty: false,
  link: false,
};

export { AddToCart };
